import { render } from "./PasPerformanceDashboard.vue?vue&type=template&id=5cf6a9a6&scoped=true"
import script from "./PasPerformanceDashboard.vue?vue&type=script&lang=js"
export * from "./PasPerformanceDashboard.vue?vue&type=script&lang=js"

import "./PasPerformanceDashboard.vue?vue&type=style&index=0&id=5cf6a9a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf6a9a6"]])

export default __exports__